import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var auditReportListRes;
export const auditReportListTodo = createAsyncThunk('auditReportList', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'audit_report_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return auditReportListRes = res.data
    } catch (error) {
        return auditReportListRes = error.response.data
    }
})


const auditReportListSlice = createSlice({
    name: 'auditReportList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(auditReportListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('auditReportList', state.data)
            }
        });
        builder.addCase(auditReportListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default auditReportListSlice.reducer; 